module.exports = __webpack_public_path__ + "img/cordial@2x.f55f962.jpg";